import React from 'react';
import PersistentIframeController from 'src/components/common/persistentIframeRenderer/PersistentIframeController';
import { IframeApps } from 'src/components/common/persistentIframeRenderer/constants';
import Navbar from 'src/components/navbar/Navbar';
import { useTranslation } from 'react-i18next';
import DocumentTitle from 'react-document-title';
import { getFullRouteForId } from './routes';

const AddressResolutionApp = ({ }) => {
  const { t } = useTranslation();
  return (
    <>
    <Navbar  
     pageTitle={t('Address Resolution Agent')}
     />
    <DocumentTitle title={t('Address Resolution Agent')} />
    <PersistentIframeController
      route={getFullRouteForId('agent')}
      appName={IframeApps.SHIPSY_AGENT}
    />
    </>
  );
};

export default AddressResolutionApp;